import { ProductSorting } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { DropdownField, DropdownOption } from '@components';
import { INITIAL_CATEGORY_STATE } from '@hooks/category/category.hook';
import { useAppSelector } from '@hooks/redux/store.hooks';
import { getProducts } from '@store/products/products.slice';
import { t } from '@translations';
import { useMemo } from 'react';

// TYPES
//--------

export type CategorySortingProps = {
  onChange?: Function;
  isWorking?: boolean;
  productCount?: number;
};

export const CategorySorting = ({ onChange, isWorking, productCount }: CategorySortingProps) => {
  const searchParams = new URLSearchParams(window.location.search);
  const value = (searchParams.get('sorting') as ProductSorting) || INITIAL_CATEGORY_STATE.sorting;
  const products = useAppSelector(getProducts);

  const handleChange = (sortingValue?: string) => {
    if (typeof onChange === 'function' && sortingValue) {
      onChange(sortingValue);
    }
  };
  const options = useMemo<DropdownOption<ProductSorting>[]>(
    () => [
      { label: t(TextCodes.Sorting.PriceAsc), value: 'PriceAsc' },
      { label: t(TextCodes.Sorting.PriceDesc), value: 'PriceDesc' },
      { label: t(TextCodes.Sorting.NameAsc), value: 'NameAsc' },
      { label: t(TextCodes.Sorting.NameDesc), value: 'NameDesc' },
    ],
    []
  );
  if (!onChange) {
    return null;
  }

  return (
    <DropdownField
      label={t(TextCodes.Sorting.Sorting)}
      value={options.find((option) => option.value === value)?.label || ''}
      options={options}
      getValue={(value: string | string[]) => handleChange(value as string)}
      disabled={isWorking || (products?.items?.length ?? 0) <= 1}
    />
  );
};
